<template>
  <div>
      <!-- Button from scatch -->
        <CRow class="btnContainer" @click="changeStatus">
          <div class="col-2">
            <img src="@/assets/icons/google.png" width="33" height="33"/>
          </div>
          <div class="col-auto" style="text-align:center">
            Sign in with google
          </div>
            <div v-if="sync" class="text-right">
              <img src="@/assets/icons/homepage/sync.svg" width="24" height="24" class="text-right" style="margin-left: 0.875rem"/>
            </div>
            <div v-else class="text-right">
              <img src="@/assets/icons/homepage/unsync.svg" width="24" height="24" class="text-right" style="margin-left: 0.875rem"/>
            </div>
          <!-- <div v-else-if="!sync" class="col-2">
            <i class="fa fa-exclamation-circle fa-2x"></i>
          </div> -->
        </CRow>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        sync: false
      }
    },
    methods: {
      changeStatus() {
        this.sync= !this.sync;
      }
    }
  }
</script>

<style scoped>
.btnContainer {
  padding-right: 1.2rem;
  width: 270px;
  height: 52px;
  background:#EFEFEF;
  border-radius: 50px;
  align-items: center;
}

.btnContainer:hover {
  cursor:pointer;
}
</style>